<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="heroBannerForm"
      ref="heroBannerForm"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card" v-model="pageLangCode">
        <el-tab-pane
          :name="langItem.lang"
          :label="$t('message.' + langItem.lang)"
          v-for="(langItem, index) in heroBannerForm.lstLang"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> File Type </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'lstLang.' + index + '.fileType'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select v-model="langItem.fileType">
                      <el-option
                        v-for="item in [
                          { val: 1, text: 'Picture' },
                          { val: 2, text: 'Video' },
                        ]"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="langItem.fileType == 1">
                <label class="col-sm-2 control-label"> Banner Image </label>
                <div class="col-sm-10">
                  <el-upload
                    class="upload-demo upload-image"
                    action="#"
                    multiple
                    :http-request="uploadFile"
                    :auto-upload="true"
                    accept=".png, .jpg , .jpeg"
                    :show-file-list="false"
                  >
                    <div
                      slot="tip"
                      v-if="uploadErr"
                      style="color: red; font-size: 10px"
                      class="el-upload__tip"
                    >
                      The uploaded file should not exceed 5MB
                    </div>
                    <div class="input-group img-group">
                      <div class="text-center dropzone logo">
                        <div
                          class="addImage"
                          v-if="!langItem.fileShowUrl"
                          style="width: 100%; padding-top: 25px; color: #fff"
                        >
                          <a class="addImageIcon btn btn-primary btn-circle">
                            <i class="el-icon-upload2"></i>
                          </a>
                          <p class="text-primary m-t-sm font14 suggestFont">
                            <slot name="sizeHint"></slot>
                          </p>
                        </div>
                        <div class="editImage" v-if="langItem.fileShowUrl">
                          <div class="mask-bg"></div>
                          <img :src="langItem.fileShowUrl" />
                          <div class="icon-center">
                            <span class="edit-icon">
                              <i class="el-icon-edit"></i>
                            </span>
                            <p class="font14 font-white editFont">Modify</p>
                            <p
                              class="
                                text-primary
                                font-white
                                m-t-sm
                                font14
                                suggestFont
                              "
                            >
                              <slot name="sizeHint"></slot>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-upload>
                  <el-form-item
                    :prop="'lstLang.' + index + '.fileUrl'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-input
                      style="display: none"
                      v-model="langItem.fileUrl"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                  <div>
                    * The banner image is default mapping to three languages.
                    For change the image by single language, please select the
                    language and click the image for update.*
                  </div>
                </div>
              </div>
              <!--TODO-->
              <template v-if="langItem.fileType == 2">
                <div class="form-group">
                  <label class="col-sm-2 control-label"> Banner Video </label>
                  <div class="col-sm-10">
                    <el-form-item
                      :prop="'lstLang.' + index + '.fileUrl'"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      }"
                    >
                      <el-input
                        style="margin-bottom: 22px"
                        v-model="langItem.fileUrl"
                        show-word-limit
                      ></el-input>
                      <video
                        :src="langItem.fileUrl"
                        style="width: 100%"
                        controls="controls"
                      ></video>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">
                    Thumbnail Image
                  </label>
                  <div class="col-sm-10">
                    <el-upload
                      class="upload-demo upload-image"
                      action="#"
                      multiple
                      :http-request="uploadFile"
                      :auto-upload="true"
                      accept=".png, .jpg , .jpeg"
                      :show-file-list="false"
                    >
                      <div
                        slot="tip"
                        v-if="uploadErr"
                        style="color: red; font-size: 10px"
                        class="el-upload__tip"
                      >
                        The uploaded file should not exceed 5MB
                      </div>
                      <div class="input-group img-group">
                        <div class="text-center dropzone logo">
                          <div
                            class="addImage"
                            v-if="!langItem.coverImageUrl"
                            style="width: 100%; padding-top: 25px; color: #fff"
                          >
                            <a class="addImageIcon btn btn-primary btn-circle">
                              <i class="el-icon-upload2"></i>
                            </a>
                            <p class="text-primary m-t-sm font14 suggestFont">
                              <slot name="sizeHint"></slot>
                            </p>
                          </div>
                          <div class="editImage" v-if="langItem.coverImageUrl">
                            <div class="mask-bg"></div>
                            <img :src="langItem.coverImageUrl" />
                            <div class="icon-center">
                              <span class="edit-icon">
                                <i class="el-icon-edit"></i>
                              </span>
                              <p class="font14 font-white editFont">Modify</p>
                              <p
                                class="
                                  text-primary
                                  font-white
                                  m-t-sm
                                  font14
                                  suggestFont
                                "
                              >
                                <slot name="sizeHint"></slot>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-upload>
                  </div>
                </div>
              </template>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Description </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="`lstLang[${index}].description`"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="langItem.description"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="hr-line-dashed"></div>
            <div class="form-group">
              <div class="col-sm-12">
                <div class="pull-right">
                  <el-button
                    type="primary"
                    @click="checkEvent()"
                    v-if="
                      (checkPermission('REWARDS_LIST_EDIT') &&
                        $route.query.id) ||
                      (checkPermission('REWARDS_LIST_ADD') && !$route.query.id)
                    "
                    >Save</el-button
                  >
                  <el-button @click="showWarning()">{{
                    $t("message.Cancel")
                  }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      pageLangCode: "en_US",
      uploadErr: false,
      detailInfo: {
        lstWebsiteChallengeCorner: [
          {
            type: 1,
            lstLang: [],
          },
          {
            type: 2,
            lstLang: [],
          },
          {
            type: 3,
            lstLang: [],
          },
        ],
      },
      heroBannerForm: {
        type: 1,
        lstLang: [],
      },
    };
  },
  computed: {},
  watch: {
    detailInfo: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  created() {
    var obj = [];
    this.pageLangCode = this.$store.state.userInfo.language[0].langCode;
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        fileUrl: "",
        fileType: 1,
        description: "",
        lang: this.$store.state.userInfo.language[i].langCode,
        fileShowUrl: "",
        fileChangeSaveUrl: "",
      });
    }
    this.detailInfo.lstWebsiteChallengeCorner.forEach((i) => {
      this.$set(i, "lstLang", obj);
    });
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      var that = this;
      let obj = this.getAuthObj();
      obj.apiUrl = "/websiteChallengeCorner/detail";
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.$set(this, "detailInfo", data.data.result);
      setTimeout(function () {
        that.$store.state.edit = false;
      }, 500);
      
      if(!this.detailInfo.lstWebsiteChallengeCorner[0].lstLang.length){
        this.$store.state.userInfo.language.forEach(i=>{
          this.detailInfo.lstWebsiteChallengeCorner[0].lstLang.push({
            coverImage: "",
            coverImageUrl: "",
            description: "",
            fileShowUrl: "",
            fileType: 1,
            fileUrl: "",
            lang: i.langCode
          })
        })
      }
      this.heroBannerForm = this.detailInfo.lstWebsiteChallengeCorner[0];
    },
    checkEvent: function () {
      this.$refs["heroBannerForm"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    async uploadFile(params) {
      if (!this.handleCheckUploadFileSize(params.file)) return false;
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      const langObj = this.heroBannerForm.lstLang.find((i) => {
        return this.pageLangCode == i.lang;
      });

      langObj[langObj.fileType == 1 ? "fileUrl" : "coverImage"] =
        data.data.result.url;
      langObj[langObj.fileType == 1 ? "fileShowUrl" : "coverImageUrl"] =
        data.data.result.showUrl;
    },
    async submit() {
      try {
        this.detailInfo.lstWebsiteChallengeCorner[0] = this.heroBannerForm;
        let obj = this.getAuthObj();
        obj.userId = this.$store.state.userInfo.userId;
        obj.lstWebsiteChallengeCorner =
          this.detailInfo.lstWebsiteChallengeCorner;
        var data;
        obj.apiUrl = "/websiteChallengeCorner/update";
        data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
        }
      } catch (err) {}
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {},
    handleCheckUploadFileSize(file) {
      const sizeKB = file.size / 1024;
      if (sizeKB > 5120) {
        this.uploadErr = true;
        return false;
      } else {
        this.uploadErr = false;
        return true;
      }
    },
  },
};
</script>
